import {
  BOGGLE_GOLD_SCORE_BONUS,
  BOGGLE_GOLD_TILE_KIND,
  countBoggleSpecialTilesInPath,
  getBoggleSpecialTileScoreBonus,
  isBoggleSpecialTile,
} from '~/boggle/engine/specialTiles'
import { isGoldRushBurstActive } from '~/boggle/lib/meterBursts'
import type { BoggleBoard, BoggleGameState, BogglePosition } from './types'

export function isBoggleGoldRushActive(
  state: Pick<BoggleGameState, 'meter' | 'playgroundSettings'>,
) {
  return isGoldRushBurstActive(state.playgroundSettings.meter, state.meter)
}

export function countEffectiveBoggleGoldTilesInPath(
  state: Pick<BoggleGameState, 'board' | 'meter' | 'playgroundSettings'>,
  positions: readonly BogglePosition[],
) {
  return isBoggleGoldRushActive(state)
    ? positions.length
    : countBoggleSpecialTilesInPath(state.board, positions, BOGGLE_GOLD_TILE_KIND)
}

export function getEffectiveBoggleSpecialTileScoreBonus(
  state: Pick<BoggleGameState, 'board' | 'meter' | 'playgroundSettings'>,
  positions: readonly BogglePosition[],
) {
  const actualBonus = getBoggleSpecialTileScoreBonus(state.board, positions)
  if (!isBoggleGoldRushActive(state)) {
    return actualBonus
  }

  const actualGoldCount = countBoggleSpecialTilesInPath(
    state.board,
    positions,
    BOGGLE_GOLD_TILE_KIND,
  )
  const virtualGoldCount = Math.max(0, positions.length - actualGoldCount)

  return actualBonus + virtualGoldCount * BOGGLE_GOLD_SCORE_BONUS
}

export function getBoggleCellEffectiveGold(
  state: Pick<BoggleGameState, 'meter' | 'playgroundSettings'>,
  cell: BoggleBoard[number][number],
) {
  return (
    isBoggleSpecialTile(cell, BOGGLE_GOLD_TILE_KIND) ||
    (cell !== null && isBoggleGoldRushActive(state))
  )
}
